// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cqkq","delete":"styles_delete__2o2zG","update":"styles_update__1C-PS","add":"styles_add__N153Q"};